import React from "react";
import { RiFileList3Line, RiShoppingBag3Line, RiTimeLine, RiWallet3Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../hooks/usePermission";

const CommonFooter = ({ page }) => {
  const { hasPageAccess } = usePermission();
  const nav = useNavigate();
  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo"));
  const userType = sessionStorage.getItem("userType");
  const businessType = adminInfo?.businessType;
  const UserType = parseInt(userType);
  return (
    <div>
      {[3, 4, 5].includes(UserType) && (
        <>
          {businessType === 1 && (
            <nav className="fixed z-50 rounded-t-3xl text-[20px] max-w-[768px] mx-auto bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-3 px-6 flex justify-between">
              {hasPageAccess("insight") && (<NavButton
                active={page === "Insight"}
                path="/dashboard"
                navigateTo={nav}
                icon={<i className="ri-home-line"></i>}
              />)}
              {hasPageAccess("departmentwisesales") && (<NavButton
                active={page === "Department wise Sales"}
                path="/dept-sales"
                navigateTo={nav}
                icon={<i className="ri-building-line"></i>}
              />)}
              {hasPageAccess("hourlysales") && (<NavButton
                active={page === "Hourly Sales"}
                path="/hourly-sales"
                navigateTo={nav}
                icon={<i className="ri-time-line"></i>}
              />)}
              {hasPageAccess("topsellingproducts") && (<NavButton
                active={page === "Top Selling Products"}
                path="/top-products"
                navigateTo={nav}
                icon={<i className="ri-fire-line"></i>}
              />)}
            </nav>
          )}
          {businessType === 2 && (
            <nav className="fixed z-50 rounded-t-3xl text-[20px] max-w-[768px] mx-auto bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-3 px-6 flex justify-between">
              {hasPageAccess("restaurantinsight") && (<NavButton
                active={page === "Insight"}
                path="/restaurantDashboard"
                navigateTo={nav}
                icon={<i className="ri-home-line"></i>}
              />)}
              {hasPageAccess("dailypaymentsummary") && (<NavButton
                active={page === "Daily Payment Summary"}
                path="/payment-wise-summary"
                navigateTo={nav}
                 icon={<RiWallet3Line />}
              />)}
              {hasPageAccess("dailysalessummary") && (<NavButton
                active={page === "Daily Sales Summary"}
                path="/sales-wise-summary"
                navigateTo={nav}
                icon={<RiShoppingBag3Line />}
              />)}
              {hasPageAccess("dailytimewisesalessummary") && (<NavButton
                active={page === "Daily Timewise Sales Summary"}
                path="/time-wise-daily-summary"
                navigateTo={nav}
                icon={<RiTimeLine  />}
              />)}
              {hasPageAccess("dailyliveorderssummary") && (<NavButton
                active={page === "Daily Live Orders Summary"}
                path="/live-order-wise-summary"
                navigateTo={nav}
                icon={<RiFileList3Line />}
              />)}
            </nav>
          )}
        </>
      )}
    </div>
  );
};
const NavButton = ({ icon, path, navigateTo, active = false }) => (
  <button
    onClick={() => navigateTo(path)}
    className={`p-2 rounded-full ${
      active ? "text-indigo-600" : "text-gray-500"
    }`}
  >
    {icon}
  </button>
);

export default CommonFooter;
